import {
    getModule,
    getModuleName,
    getModules,
    getAcl,
    getUrl,
    getTools,
    getTool,
} from '@/app/shared/utils/stateGetterUtils';

const getters = {
    getCodeModule: state => state.data.code,
    getCodeApiModule: state => state.data.codeAPI,
    getModule: state => getModule(state),
    getModuleName: state => getModuleName(state),
    getModules: state => getModules(state),
    getTools: state => getTools(state),
    getTool: (state) => (id) => {
        return getTool(state, id);
    },
    getAcl: (state, getters) => (id) => {
        return getAcl(state, getters.getTools, id);
    },
    getUrl: (state, getters) => (id) => {
        return getUrl(state, getters.getTools, id);
    },
};

export default getters;
